import { useEffect } from "react";

// Keeps the screen awake while `active` — used wherever a QR code is on
// display, because a phone that sleeps mid-scan ends the conversation. The OS
// releases the lock whenever the page loses visibility, so it is re-requested
// on every return to the foreground. Older iOS (pre-16.4) has no Wake Lock
// API; there the hook is a silent no-op and the normal auto-lock timer applies.
export function useWakeLock(active) {
  useEffect(() => {
    if (!active || !navigator.wakeLock) return;
    let lock = null;
    const grab = () =>
      navigator.wakeLock
        .request("screen")
        .then((l) => (lock = l))
        .catch(() => {}); // denied (low battery mode etc.) — nothing to do
    const onVisible = () => {
      if (document.visibilityState === "visible") grab();
    };
    grab();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      lock?.release().catch(() => {});
    };
  }, [active]);
}
